import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
// import advancedFormat from 'dayjs/plugin/advancedFormat' // try require?

import { bem } from '@argos/utils'
import ArgosIcon from '../../Common/Icons/Argos'

// dayjs.extend(advancedFormat)

const cn = bem({ prefix: 'lc-', block: 'welcome-header' })

const WelcomeHeader = ({ chatStartTime }) => (
  <div className={cn()} data-test={cn()}>
    <ArgosIcon className={cn('icon')} />

    <h2 className={cn('title')}>Welcome to live chat</h2>

    {/* dayjs advanced format plugin breaking webpack - remove ordinals temporarily */}
    {/* <p className={cn('subtitle')}>{chatStartTime && dayjs(chatStartTime).format('Do MMMM YYYY h:mma')}</p> */}
    <span className={cn('subtitle')}>{chatStartTime && dayjs(chatStartTime).format('D MMMM YYYY h:mma')}</span>
  </div>
)

WelcomeHeader.defaultProps = {
  chatStartTime: null,
}

WelcomeHeader.propTypes = {
  chatStartTime: PropTypes.string,
}

export default WelcomeHeader
